/* eslint-disable @typescript-eslint/no-explicit-any */

const DogeIcon = ({ props }: any) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.2102 7.01611H8.95996V9.4809H10.9269V10.5129H8.95996V12.9775H10.2714C10.6084 12.9775 13.0378 13.0156 13.034 10.1099C13.0303 7.20433 10.6778 7.01611 10.2102 7.01611Z"
            fill="#C2A633"
        />
        <path
            d="M10 1.25C5.16746 1.25 1.25 5.16746 1.25 10C1.25 14.8325 5.16746 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16746 14.8325 1.25 10 1.25ZM10.3438 14.7259H7.17498V10.5131H6.05795V9.48113H7.17489V5.26809H9.89456C10.538 5.26809 14.7995 5.13448 14.7995 10.076C14.7995 15.0993 10.3439 14.7259 10.3439 14.7259H10.3438Z"
            fill="#C2A633"
        />
    </svg>
)
export default DogeIcon
